"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/RightToolbar/index.vue"));
var _payment = require("@/api/system/payment");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var defaultFormData = {
  id: '',
  merchantName: '',
  appId: '',
  privateKey: '',
  alipayPublicKey: '',
  alipayPublicKey2: '',
  sellerId: '',
  dailyLimitAmount: 1,
  status: 0,
  supportWap: 0,
  supportApp: 0,
  supportPc: 0,
  wapWeight: 0,
  appWeight: 0,
  pcWeight: 0,
  remark: ''
};
var _default = exports.default = {
  name: 'AlipayList',
  components: {
    RightToolbar: _index.default
  },
  data: function data() {
    return {
      // 遮罩层
      loading: false,
      statusOptions: [{
        label: '启用',
        value: 1,
        tag: 'green'
      }, {
        label: '禁用',
        value: 0,
        tag: 'red'
      }],
      supportOptions: [{
        label: '支持',
        value: 1,
        tag: 'green'
      }, {
        label: '不支持',
        value: 0,
        tag: 'red'
      }],
      // 表单校验
      rules: {
        merchantName: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请填写商户名称'
        }],
        appId: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请填写支付宝应用ID'
        }],
        privateKey: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请填写商户私钥'
        }],
        alipayPublicKey: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请填写支付宝公钥'
        }],
        alipayPublicKey2: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请填写支付宝公钥2'
        }],
        // sellerId: [{ required: true, trigger: ['blur', 'change'], message: '请填写支付宝公钥2' }],
        dailyLimitAmount: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请填写每日收款上限'
        }],
        status: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请选择状态'
        }],
        supportWap: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请选择WAP支付'
        }],
        supportApp: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请选择APP支付'
        }],
        supportPc: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请选择PC支付'
        }],
        wapWeight: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请填写WAP支付权重'
        }],
        appWeight: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请填写APP支付权重'
        }],
        pcWeight: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请填写PC支付权重'
        }]
      },
      // 弹出层标题
      title: '',
      // 是否显示弹出层
      editType: '',
      open: false,
      // 表单参数
      form: _objectSpread({}, defaultFormData)
    };
  },
  computed: {
    formData: function formData() {
      return [{
        label: '商户名称',
        prop: 'merchantName',
        defaultValue: '',
        type: 'input'
      }, {
        label: '支付宝应用appid',
        prop: 'appId',
        defaultValue: '',
        type: 'input'
      }, {
        label: '状态',
        prop: 'status',
        defaultValue: '',
        type: 'select',
        options: {
          list: this.statusOptions
        }
      }];
    },
    columns: function columns() {
      return [{
        key: 'id',
        visible: true,
        label: "id",
        width: 70
      }, {
        key: 'merchantName',
        visible: true,
        label: "\u5546\u6237\u540D\u79F0",
        width: 90
      }, {
        key: 'appId',
        visible: true,
        label: "\u652F\u4ED8\u5B9D\u5E94\u7528ID",
        width: 160
      }, {
        key: 'status',
        visible: true,
        label: "\u72B6\u6001",
        width: 80
      }, {
        key: 'dailyLimitAmount',
        visible: true,
        label: "\u6BCF\u65E5\u6536\u6B3E\u4E0A\u9650",
        width: 120
      }, {
        key: 'todayTotalAmount',
        visible: true,
        label: "\u4ECA\u65E5\u603B\u6536\u6B3E\u91D1\u989D",
        width: 140
      }, {
        key: 'supportWap',
        visible: true,
        label: "\u652F\u6301WAP\u652F\u4ED8",
        width: 160,
        formatter: 'tag'
      }, {
        key: 'supportApp',
        visible: true,
        label: "\u652F\u6301APP\u652F\u4ED8",
        width: 160,
        formatter: 'tag'
      }, {
        key: 'supportPc',
        visible: true,
        label: "\u652F\u6301PC\u652F\u4ED8",
        width: 160,
        formatter: 'tag'
      }, {
        key: 'wapWeight',
        visible: true,
        label: "WAP\u652F\u4ED8\u6743\u91CD",
        width: 130
      }, {
        key: 'appWeight',
        visible: true,
        label: "APP\u652F\u4ED8\u6743\u91CD",
        width: 130
      }, {
        key: 'pcWeight',
        visible: true,
        label: "PC\u652F\u4ED8\u6743\u91CD",
        width: 130
      }];
    }
  },
  created: function created() {},
  methods: {
    refreshList: function refreshList() {
      this.$refs.searchPage && this.$refs.searchPage.refresh();
    },
    resetList: function resetList() {
      this.$refs.searchPage && this.$refs.searchPage.resetSearch();
    },
    getList: function getList(query) {
      var params = _objectSpread({}, query);
      return (0, _payment.getAlipayList)(params);
    },
    formatter: function formatter(key, value) {
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'text';
      var defaultValue = type === 'text' ? '-' : '';
      var valueKey = type === 'text' ? 'label' : 'tag';
      if (key === 'status') {
        var target = this.statusOptions.find(function (item) {
          return item.value === value;
        });
        return target && target[valueKey] || defaultValue;
      }
      if (['supportWap', 'supportApp', 'supportPc'].includes(key)) {
        var _target = this.supportOptions.find(function (item) {
          return item.value === value;
        });
        return _target && _target[valueKey] || defaultValue;
      }
      return defaultValue;
    },
    handleStatusChange: function handleStatusChange(row) {
      var _this = this;
      var func = row.status === 1 ? _payment.enableAlipay : _payment.disableAlipay;
      this.loading = true;
      func(row.id).then(function (res) {
        _this.loading = false;
        _this.$message.success('更新状态成功');
      }).catch(function () {
        _this.loading = false;
        _this.$message.error('更新状态失败');
        row.status = row.status ? 0 : 1;
      });
    },
    /** 取消按钮 */cancel: function cancel() {
      this.editType = '';
      this.open = false;
    },
    /** 表单重置 */reset: function reset() {
      this.form = _objectSpread({}, defaultFormData);
      this.resetForm('form');
    },
    /** 新增按钮操作 */handleAdd: function handleAdd() {
      this.reset();
      this.editType = 'add';
      this.title = '添加商户';
      this.open = true;
    },
    /** 复制按钮操作 */handleCopy: function handleCopy(row) {
      var _this2 = this;
      this.loading = true;
      (0, _payment.getAlipayDetail)(row.id).then(function (data) {
        _this2.form = _objectSpread({}, data);
        _this2.editType = 'copy';
        _this2.title = '复制商户';
        _this2.open = true;
      }).finally(function () {
        _this2.loading = false;
      });
    },
    /** 修改按钮操作 */handleUpdate: function handleUpdate(row) {
      var _this3 = this;
      this.loading = true;
      (0, _payment.getAlipayDetail)(row.id).then(function (data) {
        _this3.form = _objectSpread({}, data);
        _this3.editType = 'edit';
        _this3.title = '修改商户';
        _this3.open = true;
      }).finally(function () {
        _this3.loading = false;
      });
    },
    /** 提交按钮 */submitForm: function submitForm() {
      var _this4 = this;
      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this4.loading = true;
          var params = _objectSpread(_objectSpread({}, _this4.form), {}, {
            taskId: _this4.editType === 'edit' ? _this4.form.taskId : undefined
          });
          var func = _this4.editType === 'edit' ? _payment.updateAlipay : _payment.createAlipay;
          func(params).then(function (res) {
            _this4.loading = false;
            _this4.$message.success('保存成功');
            _this4.open = false;
            _this4.refreshList();
          }).catch(function (err) {
            _this4.loading = false;
            console.error('更新商户失败：', err);
            _this4.$message.error('保存失败');
          });
        }
      });
    },
    /** 删除按钮操作 */handleDelete: function handleDelete(row) {
      var _this5 = this;
      this.$modal.confirm('是否确认删除商户名称为"' + row.merchantName + '"的数据项？').then(function () {
        return (0, _payment.deleteAlipay)(row.id);
      }).then(function () {
        _this5.$message.success('删除成功');
        _this5.refreshList();
      }).catch(function (err) {
        console.error('删除商户失败：', err);
        _this5.$message.error('删除商户失败');
      });
    }
  }
};